/**
 * NFT Metadata Configuration
 * 
 * This file contains the configuration for NFT metadata.
 * Edit this file to customize the metadata for your NFTs.
 */

/**
 * Default NFT metadata template
 * This is used as a base for all NFTs
 */
const DEFAULT_METADATA = {
  // Project name that appears in the NFT name
  projectName: "Base It",
  
  // NFT name template - supports the following variables:
  // {timestamp} - Current timestamp
  // {index} - NFT index/number
  nameTemplate: "Base It NFT #{index}",
  
  // NFT description template - supports the same variables as nameTemplate
  descriptionTemplate: "A unique NFT created with Base blue stripe effects using the Base It app in Base/Farcaster. This NFT represents a transformed image with distinctive Base brand styling.",
  
  // External URL to your project
  externalUrl: "https://base-it.vercel.app/"
};

/**
 * Generate metadata for an NFT
 * @param {Object} options - Metadata options
 * @param {string} options.imageUrl - URL to the converted image
 * @param {number} options.index - NFT index/number (optional)
 * @param {string} options.name - Custom name (optional, overrides nameTemplate)
 * @param {string} options.description - Custom description (optional, overrides descriptionTemplate)
 * @returns {Object} The metadata object
 */
function generateMetadata({
  imageUrl,
  index = 1,
  name,
  description
}) {
  // Variables for templates
  const variables = {
    timestamp: new Date().toISOString(),
    index: index
  };
  
  // Replace variables in templates or use custom values if provided
  const finalName = name || replaceVariables(DEFAULT_METADATA.nameTemplate, variables);
  const finalDescription = description || replaceVariables(DEFAULT_METADATA.descriptionTemplate, variables);
  
  // Create metadata object without attributes
  const metadata = {
    name: finalName,
    description: finalDescription,
    image: imageUrl,
    external_url: DEFAULT_METADATA.externalUrl
  };
  
  return metadata;
}

/**
 * Replace variables in a template string
 * @param {string} template - Template string with variables in {variableName} format
 * @param {Object} variables - Object with variable values
 * @returns {string} Template with variables replaced
 */
function replaceVariables(template, variables) {
  let result = template;
  for (const [key, value] of Object.entries(variables)) {
    result = result.replace(new RegExp(`{${key}}`, 'g'), value);
  }
  return result;
}

export {
  DEFAULT_METADATA,
  generateMetadata
};
